var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "businessDailyReport" }, [
    _c("div", { staticClass: "banner" }, [
      _c("img", {
        staticClass: "banner-img1",
        attrs: {
          src: require("@/assets/images/recharge/Top01.png"),
          alt: "逆向退货",
        },
        on: { click: _vm.goToReturnPickupPrint },
      }),
      _c("img", {
        staticClass: "banner-img2",
        style: {
          width: _vm.drawerSize,
          "margin-left": _vm.marginleft,
          "margin-top": _vm.marginTop,
        },
        attrs: {
          src: require("@/assets/images/recharge/Content.png"),
          alt: "逆向退货",
        },
      }),
      _c("img", {
        staticClass: "banner-img1 fixed-btn",
        attrs: {
          src: require("@/assets/images/recharge/bottom.png"),
          alt: "逆向退货",
        },
        on: { click: _vm.goToReturnPickupPrint },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }